
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("b9sjx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e1bba88828ac23a0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $e1bba88828ac23a0$export$2e2bcd8739ae039 = {
    'fabric.editor.chromeCollapsedPlaceholder': "Saisissez quelque chose\u2026",
    'fabric.editor.editorAssistiveLabel': "Zone de contenu principale, commencez \xe0 taper pour saisir du texte.",
    'fabric.editor.headingLink.toolbarHelpTitle': "Ouvrir la bo\xeete de dialogue d'aide"
};

});


//# sourceMappingURL=fr.76417c5b.js.map
